import * as actionTypes from '../types/finishedProduct';

const initialState = {
  listFinishedProduct: [],
  listFinishedProductNormalizedToTable: [],
  okGetProduct: false,
  loadingGet: false,
  loading: false,
  okRequest: false
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.CONFIRM_FINISHED_PRODUCT:
    case actionTypes.STORNO_FINISHED_PRODUCT:
    case actionTypes.SET_CANCEL_SEND_TO_SAP:
      return {
        ...state,
        okRequest: false,
        loading: true
      };

    case actionTypes.GET_FINISHED_PRODUCT:
      return {
        ...state,
        okGetProduct: false,
        loadingGet: true
      };

    case actionTypes.GET_FINISHED_PRODUCT_SUCCESS:
      return {
        ...state,
        listFinishedProduct: payload,
        listFinishedProductNormalizedToTable: payload.map((el) => ({
          ...el.semiProduct,
          readyProfileSize: el.readyProduct.profileSize,
          readyAccountingDate: el.readyProduct.accountingDate,
          readyBatchId: el.readyProduct.batchId,
          readyQcId: el.readyProduct.qcId,
          readyPieceId: el.readyProduct.pieceId,
          readyPsStatusName: el.readyProduct.psStatusName,
          readyPsStatusNumId: el.readyProduct.psStatusNumId,
          readyWeightNetto: el.readyProduct.weightNetto,
          readyZdvlOrderId: el.readyProduct.zdvlOrderId,
          readyZdvlLineNumId: el.readyProduct.zdvlLineNumId,
          readyZdvlLineId: el.readyProduct.zdvlLineId,
          readyWeightOff: el.readyProduct.weightOff,
          readyLength: el.readyProduct.length,
          readyThickness: el.readyProduct.thickness,
          readyMark: el.readyProduct.mark,
          readyNormativeDoc: el.readyProduct.normativeDoc,
          readyQty: el.readyProduct.qty,
          readyOperationNumId: el.readyProduct.operationNumId,
          readyPieceNumId: el.readyProduct.pieceNumId,
          // eslint-disable-next-line max-len,no-restricted-globals
          percentWasteMaterial: isNaN(el.semiProduct.percentWasteMaterial) ? 0 : el.semiProduct.percentWasteMaterial,
          finishedProductId: `${el.readyProduct.pieceNumId}${el.semiProduct.pieceNumId}`,
          readyMessageId: el.readyProduct.messageId
        })),
        loadingGet: false,
        okGetProduct: true
      };

    case actionTypes.GET_FINISHED_PRODUCT_FAIL:
      return {
        ...state,
        loadingGet: false,
        okGetProduct: false
      };

    case actionTypes.CONFIRM_FINISHED_PRODUCT_SUCCESS:
    case actionTypes.STORNO_FINISHED_PRODUCT_SUCCESS:
    case actionTypes.SET_CANCEL_SEND_TO_SAP_SUCCESS:
      return {
        ...state,
        loading: false,
        okRequest: true
      };

    case actionTypes.CONFIRM_FINISHED_PRODUCT_FAIL:
    case actionTypes.STORNO_FINISHED_PRODUCT_FAIL:
    case actionTypes.SET_CANCEL_SEND_TO_SAP_FAIL:
      return {
        ...state,
        loading: false,
        okRequest: false
      };

    default:
      return state;
  }
};

export default reducer;
